<ion-toolbar>
	<ion-buttons slot="end" collapse="false">
		<ion-button
			(click)="onClick()"
			[color]="color"
			fill="solid"
			shape="round"
			[size]="size"
			class="button__add"
		>
			<ion-icon name="add-outline"></ion-icon>
		</ion-button>
	</ion-buttons>
	<ng-container *ngIf="isButton; else titleSection">
		<ion-button (click)="onClickPrimary()">
			{{ title }}
		</ion-button>
	</ng-container>
	<ng-template #titleSection>
		<ion-title *ngIf="title">
			<div class="title">{{ title }}</div>
		</ion-title>
	</ng-template>
</ion-toolbar>
